<!-- sections/AdditionalFieldsSection.vue -->
<script setup lang="ts">
import BaseSection from '../components/BaseSection.vue';
import ConnxField, { ErrorUpdate } from '@/components/Molecules/Field/ConnxField.vue';
import { InputType } from '@/interfaces/InputFields';

interface AdditionalField {
  key: string;
  label: string;
  value: any;
  type: InputType;
  values?: Array<{ label: string; value: any }>;
  inline?: boolean;
}

interface Props {
  fields?: AdditionalField[];
  errors?: Map<string, string | null>;
  showTitle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  fields: () => [],
  errors: () => new Map(),
  showTitle: true,
});

const emit = defineEmits<{
  'field-error': [{ name: string; error: string | null }];
  'update:field': [{ key: string; value: any }];
}>();

const handleFieldError = (error: ErrorUpdate) => {
  emit('field-error', error);
};

const handleFieldUpdate = (key: string, value: any) => {
  emit('update:field', { key, value });
};
</script>

<template>
  <BaseSection :should-show="fields && fields.length > 0" :show-title="showTitle">
    <connx-field
      v-for="field in fields"
      :key="field.key"
      :name="field.key"
      :label="field.label"
      :model-value="field.value"
      :type="field.type"
      :options="field.values"
      :inline="field.type === InputType.Radio"
      @update:model-value="(val) => handleFieldUpdate(field.key, val)"
      @update:error="handleFieldError"
    />
  </BaseSection>
</template>
